// extracted by mini-css-extract-plugin
export default {"one-line":"Td_one-line__rWqDD","shaded":"Td_shaded__krH3g"};